const { Rx, Vue, jQuery: $, _ } = window;

import {
	getBuildChanges,
	generateBuilderUI,
	processIncompatibilities, optionIsIncompatible,
	leadFormData
} from "../_utilities";
import { ACTIONS } from "../_actions";
import { store, store$ } from "../_config-store";
import { localize } from "../_localize.js";

const viewOption$ = store$
	.map(state => state.viewOption);

const viewOptions$ = store$
	.map(state => state.viewOptions);

const activeOption$ = store$
	.map(state => state.activeOption);

const optionInteracted$ = store$
	.map(state => state.optionInteracted);

const dataReady$ = store$
	.map(state => state.dataReady);

const truckCab$ = store$
	.map(state => state.truckCab);

const settingsBackup$ = store$
	.map(state => state.settingsBackup);

// on popstate trigger the action that was stored when storing that state
Rx.Observable.fromEvent(window, "popstate")
	.do(e => console.log("popstate", e))
	.map(e => e.state)
	.filter(action => action)
	.subscribe(action => {
		if (action.type === "CAB_RESET") {
			$("body").removeClass("configurator-open");
			$("#configurator").removeClass("open");
		}
		store.dispatch(action);
	});

// const truckModel$ = store$
// 	.map(state => state.truckModel);

// const optionDetails$ = store$
// 	.map(state => state.optionDetails);

export const optionsTray = {
	template:
		`<div id="options-tray" v-if="dataReady" v-bind:option="optionClass(activeOption || '')">
		<template v-if="truckCab">
			<transition name="slide" :duration="300">
				<keep-alive>
				<transition-group name="squish-list" tag="div" class="primary" v-bind:class="interacted" v-if="!activeOption" v-keep-scroll-position>
					<item-card 
						v-if="previous" 
						v-on:click.native="switchView(previous)" 
						class="previous"
						icon="previous" 
						option-key="previous"
						v-bind:key="previous + 'key'"
						v-bind:label="local(previous)" 
					></item-card>
					<item-card 
						v-for="option in availableOptions" 
						v-if="option.label"
						v-on:click.native="activateOption(option)" 
						option="1" 
						v-bind:interacted="optionInteracted[option.parent] && childLabels(option) !== ''"
						v-bind:label="option.label"
						v-bind:optionKey="option.altWorkflow || option.parent"
						v-bind:sub-label="childLabels(option)"
						v-bind:key="option.label"
						v-bind:icon="optionClass(option.altWorkflow || option.parent)"
					></item-card>
					<item-card 
						v-if="next" 
						v-on:click.native="switchView(next)" 
						class="next"
						icon="next"
						option-key="next"
						v-bind:key="next + 'key'"
						v-bind:label="local(next)"
					></item-card>
				</transition-group>
				</keep-alive>
			</transition>
			<transition name="slide" :duration="300">
				<div class="secondary" v-if="activeOption" v-bind:option="optionClass((availableOptions[0] || { attributes: {name:availableOptions[Object.keys(availableOptions)[0]].altWorkflow ? Object.keys(availableOptions)[0] : '' }}).attributes.name  || activeOption || 'none')">
					<h4>{{_.at(availableOptions,'[0].attributes.data-category')[0] || activeOption}}</h4>
					<template v-for="option in availableOptions">
							<template v-if="option.options"> 
								<div v-if="option.group" :class="{group: option.group}">
									<label v-if="!option.altWorkflow && option.label">{{option.groupLabel || option.label}}</label> 
									<label v-if="!option.altWorkflow && option.current">{{option.current}}</label>
									<item-card 
										v-for="optChild in option.options" 
										v-on:click.native="setOption(option, optChild.attributes['data-component'],optChild.attributes['data-key'],optChild.label,option.label,optChild.attributes['data-key'])" 
										v-bind:selected="optChild.attributes.checked"
										v-bind:label="optChild.label"
										v-bind:color="optChild.attributes.color"
										v-bind:parent="option.label"
										v-bind:optionObj="option"
										v-bind:optionKey="optChild.attributes['data-key']"
										v-bind:firstOption="optChild.attributes['first-option-key']"
										v-bind:key="optChild.attributes['data-key']"
									></item-card>
								</div>
								<template v-else>
									<label v-if="!option.altWorkflow && option.label">{{option.label}}</label> 
									<label v-if="!option.altWorkflow && option.current">{{option.current}}</label>
									<item-card 
										v-for="optChild in option.options" 
										v-on:click.native="setOption(option, optChild.attributes['data-component'],optChild.attributes['data-key'],optChild.label,option.label,optChild.attributes['data-key'])" 
										v-bind:selected="optChild.attributes.checked"
										v-bind:label="optChild.label"
										v-bind:color="optChild.attributes.color"
										v-bind:parent="option.label"
										v-bind:optionObj="option"
										v-bind:optionKey="optChild.attributes['data-key']"
										v-bind:firstOption="optChild.attributes['first-option-key']"
										v-bind:key="optChild.attributes['data-key']"
									></item-card>
								</template>
							</template>
							<template v-else> 
								<label v-if="option.current">{{option.current}}</label>
								<item-card
									v-on:click.native="setOption(option, option.attributes['data-component'],option.attributes['data-key'],option.label,option.label,option.attributes['data-key'])" 
									v-bind:selected="option.attributes.checked"
									v-bind:label="option.label"
									v-bind:color="option.attributes.color"
									v-bind:optionObj="option"									
									v-bind:parent="option.attributes['data-category']"
									v-bind:optionKey="option.attributes['data-key']"
									v-bind:firstOption="option.attributes['first-option-key']"
									v-bind:key="option.attributes['data-key']"
								></item-card>
							</template>
					
					</template>
					<label v-if="optionSubtext()" v-html="optionSubtext()"></label>
				</div>
			</transition>	
		</template>
	</div>`,
	subscriptions: function () {
		return {
			viewOption: viewOption$,
			viewOptions: viewOptions$,
			activeOption: activeOption$,
			optionInteracted: optionInteracted$,
			dataReady: dataReady$,
			truckCab: truckCab$,
			settingsBackup: settingsBackup$,
			store: store$,
		};
	},
	data() {
		return {
			leadForm: leadFormData(),
			previousSettings: {},
			local(str){
				return str;
			}
		};
	},
	computed: {
		disclaimer(){
			return this.leadForm ? this.leadForm.MaterialsDisclaimer : this.local('Additional colors available when you visit your Freightliner Dealer. <br><br> Colors are for reference only. Actual selection options may vary.');
		},
		availableOptions() {
			let state = this.store;
			let builderUI = generateBuilderUI(state);
			let activeOption = this.activeOption;
			let uiGroup = activeOption ? builderUI.find(item => {
				return item.parent === activeOption;
			}) : false;
			let inView = uiGroup ? uiGroup.options : builderUI;
			let altWorkflow = uiGroup && uiGroup.altWorkflow;

			// filter out the components that are not the same as the grouping
			// if we are in the altworkflow

			if (_.isPlainObject(inView) && altWorkflow) {
				
				inView = _.pickBy(inView, c => c && (c.label === altWorkflow || c.workflowKey === altWorkflow ));
			}

			let optionsInView = _.chain(inView).map(component => {
				return component && (component.options
					? component.options
					: component);
			}).flatten().compact().value();

			if (this.previousSettings !== this.settingsBackup) {
				this.previousSettings = this.settingsBackup;
				store.dispatch({
					type: ACTIONS.OPTIONS_IN_VIEW_CHANGE,
					data: optionsInView
				});
			}
			else {
				store.dispatch({
					type: ACTIONS.OPTIONS_IN_VIEW_SELECTION_CHANGE,
					data: optionsInView
				});
			}
			
			// console.group(builderUI);
			// console.groupEnd();
			setOnlyOptionFocus(inView);

			
			function setOnlyOptionFocus(arrOb){
				let arr = typeof arrOb === 'array' ? arr : Object.keys(arrOb).map( key => arrOb[key]);
				if(arr.length === 1 && (arr[0] || {current:''}).current){
					store.dispatch({
						type: ACTIONS.FOCUSED_OPTION_CHANGE,
						data: arr[0].current
					});
				}
			}

			return inView;
		},
		interacted() {
			return Object.keys(this.optionInteracted).length > 0 ? 'interacted' : '';
		},
		previous() {
			let option = this.viewOptions[_.findIndex(this.viewOptions, { name: this.viewOption }) - 1];
			return option ? option.name : false;
		},
		next() {
			let option = this.viewOptions[_.findIndex(this.viewOptions, { name: this.viewOption }) + 1];
			return option ? option.name : false;
		}
	},
	methods: {
		// v-on:click="switchView()"
		switchView(view) {
			let action = {
				type: ACTIONS.VIEW_OPTION_CHANGE,
				data: view
			};
			store.dispatch(action);
			window.history.pushState(action, `?${action.data.replace(' ', '').replace('&', '_')}`, ``);
		},
		childLabels(option) {
			return _.isPlainObject(option.options)
				? _.chain(option.options).map(o => {
					return o && o.current
						? `${o.altWorkflow ? `${o.label}: ` : ''}${o.current}`
						: false;
				}).compact().value().join(' / ')
				: option.current;
		},
		activateOption(option) {
			store.dispatch({
				type: ACTIONS.ACTIVE_OPTION_CHANGE,
				data: option.parent
			});
			store.dispatch({
				type: ACTIONS.FOCUSED_OPTION_CHANGE,
				data: option.current
			});
			store.dispatch({
				type: ACTIONS.BUILD_SETTINGS_BACKUP
			});

			// filter out the component that is the same as the grouping
			// and set the active option children for the dialog overlay
			if (option.altWorkflow) {
				let builderUI = generateBuilderUI(this.store)
					.filter(group => group.label === option.parent);
				let optionChildren = _.pickBy(builderUI[0].options, (component, key) => {
					return component && key !== component.altWorkflow;
				});

				store.dispatch({
					type: ACTIONS.SET_OPTION_CHILDREN,
					data: optionChildren// options.find(item => item.attributes.checked === 'checked')
				});
			}
		},
		setOption(optionObj, component, key, label, category, option) {
			store.dispatch(getBuildChanges(component, key));

			store.dispatch({
				type: ACTIONS.FOCUSED_OPTION_CHANGE,
				data: label,
				cat: category,
				option: option
			});

			if (optionObj.altWorkflow) {
				let builderUI = generateBuilderUI(this.store)
					.filter(group => group.label === optionObj.parent);
				let optionChildren = _.pickBy(builderUI[0].options, (component, key) => {
					return component && key !== component.altWorkflow;
				});
				store.dispatch({
					type: ACTIONS.SET_OPTION_CHILDREN,
					data: optionChildren
				});
			}
		},
		// details: function(key){
		// 	console.log(_.at(this.optionDetails,'["'+this.truckModel+'""]["'+this.truckCab+'""]["'+key+'""]'),key);
		// 	return _.at(this.optionDetails,'["'+this.truckModel+'""]["'+this.truckCab+'""]["'+key+'""]') ? key : false;
		// },
		optionClass(optionLabel) {
			return _.kebabCase(optionLabel.replace('™',''));
		},
		optionSubtext() {
			// text/label added to bottom of the options selector			
			switch(this.optionClass(this.activeOption)){
				case 'color':
					return this.disclaimer;
				case 'materiales':	
					return this.local('materials-option-disclaimer');
			}
			return '';
			
		}
	},
	created(){
		localize().then( local => this.local = local );
	}
};


Vue.component('options-tray', optionsTray);